import { render } from "./account.svg?vue&type=template&id=f0a90754"
const script = {}

import exportComponent from "/buddy/stephen-webster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__